var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{attrs:{"id":"content"}},[_c('section',{staticClass:"d-flex"},[_c('BreadCrumb',{attrs:{"items":_vm.$route.matched}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }